import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "flex w-full h-full max-md:overflow-y-auto no-scrollbar" }
const _hoisted_2 = { class: "flex-1 mx-auto pl-1 mt-6 max-md:px-4 md:overflow-y-auto" }
const _hoisted_3 = { class: "bg-white border border-ternary rounded-[20px] mb-8" }
const _hoisted_4 = {
  key: 0,
  class: "text-left font-medium text-[32px] leading-[32px] lg:text-[40px] lg:leading-100p text-brown"
}
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "grid grid-cols-1 grid-rows-3 md:grid-cols-2 md:grid-rows-2 gap-4 mb-6 px-4 lg:px-10 py-6" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = {
  for: "dateFrom",
  class: "block text-left font-semibold text-base leading-[21px] mb-4"
}
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = {
  for: "dateTo",
  class: "block text-left font-semibold text-base leading-[21px] mb-4"
}
const _hoisted_11 = {
  key: 0,
  class: "w-full"
}
const _hoisted_12 = {
  for: "city",
  class: "block text-left font-semibold text-base leading-[21px] mb-4"
}
const _hoisted_13 = {
  key: 1,
  class: "w-full"
}
const _hoisted_14 = { class: "flex justify-between items-center px-4 text-base text-brown" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 2,
  class: "w-full"
}
const _hoisted_17 = {
  key: 3,
  class: "flex items-center justify-start"
}
const _hoisted_18 = {
  key: 0,
  class: "px-10 pb-6"
}
const _hoisted_19 = { class: "grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-8" }
const _hoisted_20 = { class: "relative w-full flex items-center cursor-pointer" }
const _hoisted_21 = ["id", "value"]
const _hoisted_22 = { class: "block text-left font-normal text-base leading-100p text-brown ml-2 select-none" }
const _hoisted_23 = { class: "flex justify-center border-t border-ternary py-6" }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "font-semibold" }
const _hoisted_26 = {
  key: 3,
  class: "flex gap-4 mb-6"
}
const _hoisted_27 = { class: "mb-6 w-full flex flex-col items-start" }

import ActivatorsAccordionFAQ from "@/views/Calculators/Activation/components/ActivatorsAccordionFAQ.vue";
import SectorsAccordionFAQ from "@/views/Calculators/Activation/components/SectorsAccordionFAQ.vue";
import { useRoute, useRouter } from "vue-router";
import { computed, onMounted, ref } from "vue";
import {
  ActivationGroup,
  ActivationItemGroup,
  ActivationsRequest,
} from "@/types/calculators";
import { activationGroups } from "@/constants/activations";
import { useI18n } from "vue-i18n";
import AccordionFaq from "@/components/accordion/AccordionFAQ.vue";
import { fetchActivations } from "@/api/calculators";
import DatePicker from "@/components/inputs/DatePicker.vue";
import CheckIcon from "@/components/icons/CheckIcon.vue";
import GradientButton from "@/components/buttons/GradientButton.vue";
import BackSidebar from "@/views/Calculators/Activation/components/BackSidebar.vue";
import { useSafeBack } from "@/utils/useSafeBack";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { format } from "date-fns";
import ActivationResults from "@/views/Calculators/Activation/components/ActivationResults.vue";
import PageTitleWithBackButton from "@/components/PageTitleWithBackButton.vue";
import GooglePlaceAutocompleteInput from "@/components/inputs/GooglePlaceAutocompleteInput.vue";
import { useGoogleAutocomplete } from "@/utils/useGoogleAutocomplete";
import ArrowIcon from "@/components/icons/ArrowIcon.vue";
import PrintButton from "@/components/buttons/PrintButton.vue";
import { useVueToPrint } from "vue-to-print";
import { useToastNotificationStore } from "@/stores/toastNotificationStore";
import NotificationComponent from "@/components/notifications/NotificationComponent.vue";
import { PlaceSelectedPayload } from "@/types/google-places";
import { useFamilyStore } from "@/stores/familyStore";
import { useUserStore } from "@/stores/userStore";
import { PREMIUM_CALCULATORS, SUBSCRIPTION_TIERS } from "@/types/premiumTypes";
import AppDropdown from "@/components/inputs/AppDropdown.vue";
import ChevronIcon from "@/components/icons/ChevronIcon.vue";
import { FamilyMember } from "@/types/familyTypes";
import TextInput from "@/components/inputs/TextInput.vue";
import DownloadDocButton from "@/components/buttons/DownloadDocButton.vue";
import WordExporter from "@/views/Calculators/Activation/components/WordExporter.vue";
import AddOutlineButton from "@/components/buttons/AddOutlineButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivationFormView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { safeBack } = useSafeBack();
const { t } = useI18n();
const { normalizeGoogleTimeZone } = useGoogleAutocomplete("ru");
const toastStore = useToastNotificationStore();
const familyStore = useFamilyStore();
const { userHasSubscriptionWithTier } = useUserStore();

const printableRef = ref();
const isFormOpen = ref<boolean>(true);
const activationRequested = ref<boolean>(false);
const selectedActivations = ref([]);
const activationGroup = ref<ActivationGroup | null>(null);
const resultedActivations = ref<ActivationItemGroup>([]);
const birthday = ref<Date | null>(null);
const dateFrom = ref<Date | null>(null);
const dateTo = ref<Date | null>(null);
const latitude = ref<number | null>(null);
const longitude = ref<number | null>(null);
const timeZone = ref<string | null>(null);
const isLoading = ref<boolean>(false);
const isFamilyMembersDropdownOpen = ref(false);
const selectedFamilyMember = ref<FamilyMember>();

const isFieldsCorrect = computed(() => {
  let activations = activationGroup.value?.activationKeys ?? [];
  if (hasCheckboxes.value) {
    activations = selectedActivations.value;
  }

  if (
    userHasSubscriptionWithTier(
      PREMIUM_CALCULATORS.activations,
      SUBSCRIPTION_TIERS.consultant
    )
  ) {
    return (
      activations.length > 0 &&
      dateFrom.value &&
      dateTo.value &&
      // birthday.value &&
      latitude.value &&
      longitude.value &&
      timeZone.value
    );
  }

  if (
    userHasSubscriptionWithTier(
      PREMIUM_CALCULATORS.activations,
      SUBSCRIPTION_TIERS.family
    )
  ) {
    return (
      activations.length > 0 &&
      dateFrom.value &&
      dateTo.value &&
      selectedFamilyMember.value !== undefined
    );
  }

  return (
    activations.length > 0 &&
    dateFrom.value &&
    dateTo.value &&
    familyStore.familyMembers.length > 0
  );
});

const hasCheckboxes = computed(
  () => activationGroup.value && activationGroup.value.activationKeys.length > 1
);

const { handlePrint } = useVueToPrint({
  content: printableRef,
  documentTitle: "Activation Result",
  removeAfterPrint: true,
  bodyClass: "p-4",
});

onMounted(() => {
  const activation = route.query.activation?.toString() ?? null;
  activationGroup.value =
    activationGroups.find((g) => g.key === activation) ?? null;
  if (!activationGroup.value) {
    safeBack(ROUTE_NAMES.ACTIVATIONS);
  }
  loadFamilyMembers();
});

function loadFamilyMembers() {
  familyStore.loadIfNeeded().then(() => {
    if (familyStore.familyMembers.length > 0) {
      selectedFamilyMember.value = familyStore.familyMembers[0];
    }
  });
}

function changeActivation(newActivation: ActivationGroup) {
  activationGroup.value = newActivation;
  resultedActivations.value = [];
  selectedActivations.value = [];

  const newQuery = { ...route.query, activation: newActivation.key };
  router.replace({ name: route.name as string, query: newQuery });
}

function handlePlaceSelected(payload: PlaceSelectedPayload) {
  latitude.value = payload.location.lat();
  longitude.value = payload.location.lng();
  timeZone.value = normalizeGoogleTimeZone(payload.timeZone);
}

async function handleSubmit() {
  if (isLoading.value || !isFieldsCorrect.value) {
    return;
  }

  isLoading.value = true;
  try {
    resultedActivations.value = [];
    activationRequested.value = false;
    const activations = await fetchActivations(getActivationRequest());
    resultedActivations.value = activations.sort((a, b) => {
      const [dA, mA, yA] = a.date.split("-");
      const [dB, mB, yB] = b.date.split("-");
      const dateComparison = `${yA}-${mA}-${dA}`.localeCompare(
        `${yB}-${mB}-${dB}`
      );
      if (dateComparison !== 0) {
        return dateComparison;
      }

      const timeA = a.time_interval.split("-")[0];
      const timeB = b.time_interval.split("-")[0];

      return timeA.localeCompare(timeB);
    });
    activationRequested.value = true;
  } catch (e) {
    await toastStore.createNotificationsFromApi(e);
    console.log(e);
  } finally {
    isLoading.value = false;
  }
}

function getActivationRequest(): ActivationsRequest {
  let activations = activationGroup.value?.activationKeys ?? [];
  if (hasCheckboxes.value) {
    activations = selectedActivations.value;
  }
  let request = {
    activations: activations,
    dateFrom: format(dateFrom.value as Date, "yyyy-MM-dd"),
    dateTo: format(dateTo.value as Date, "yyyy-MM-dd"),
  };

  if (
    userHasSubscriptionWithTier(
      PREMIUM_CALCULATORS.activations,
      SUBSCRIPTION_TIERS.consultant
    )
  ) {
    return {
      ...request,
      type: "consultant",
      birthday: format(birthday.value as Date, "yyyy-MM-dd"),
      latitude: latitude.value as number,
      longitude: longitude.value as number,
      timezone: timeZone.value as string,
    };
  }

  if (
    userHasSubscriptionWithTier(
      PREMIUM_CALCULATORS.activations,
      SUBSCRIPTION_TIERS.family
    )
  ) {
    return {
      ...request,
      type: "family-member",
      familyMemberId: selectedFamilyMember.value?.id as number,
    };
  }

  return {
    ...request,
    type: "individual",
  };
}

function toggleForm() {
  if (resultedActivations.value.length == 0) {
    return;
  }
  isFormOpen.value = !isFormOpen.value;
}

function handleBack() {
  safeBack(ROUTE_NAMES.HOME);
}

function selectFamilyMember(familyMember: FamilyMember) {
  selectedFamilyMember.value = familyMember;
  isFamilyMembersDropdownOpen.value = false;
}

function handleOpenAddFamilyMemberModal() {
  router.replace({
    name: ROUTE_NAMES.USER,
    query: { openFamilyModal: "true" },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (activationGroup.value?.key !== undefined)
        ? (_openBlock(), _createBlock(PageTitleWithBackButton, {
            key: 0,
            "page-title": _unref(t)(`calculators.activations.group.${activationGroup.value?.key}`),
            "title-align": 'left'
          }, null, 8, ["page-title"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass([
            'w-full flex items-center px-4 lg:px-10',
            isFormOpen.value ? 'mb-4 lg:mb-10 pt-6' : 'py-2 lg:py-6',
          ]),
          onClick: toggleForm
        }, [
          _createElementVNode("span", {
            class: "size-10 shrink-0 mr-4 hidden xl:flex items-center justify-center rounded-full bg-brown hover:bg-active",
            onClick: handleBack
          }, [
            _createVNode(ArrowIcon, { class: "text-white -rotate-[135deg]" })
          ]),
          (activationGroup.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)(`calculators.activations.group.${activationGroup.value?.key}`)), 1))
            : _createCommentVNode("", true),
          (resultedActivations.value.length)
            ? (_openBlock(), _createElementBlock("svg", {
                key: 1,
                class: _normalizeClass([
              'size-8 transform transition-transform ml-auto',
              isFormOpen.value ? 'rotate-180' : 'rotate-0',
            ]),
                stroke: "currentColor",
                fill: "none",
                viewBox: "0 0 24 24"
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 9l-7 7-7-7"
                }, null, -1)
              ]))], 2))
            : _createCommentVNode("", true)
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(t)("labels.date_from")), 1),
              _createVNode(DatePicker, {
                id: "dateFrom",
                onDateSelected: _cache[0] || (_cache[0] = (newDate) => (dateFrom.value = newDate)),
                minDate: new Date('2026-07-09'),
                maxDate: new Date('2027-10-09')
              }, null, 8, ["minDate", "maxDate"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(t)("labels.date_to")), 1),
              _createVNode(DatePicker, {
                id: "dateTo",
                onDateSelected: _cache[1] || (_cache[1] = (newDate) => (dateTo.value = newDate)),
                minDate: new Date('2026-07-09'),
                maxDate: new Date('2027-10-09')
              }, null, 8, ["minDate", "maxDate"])
            ]),
            (
                _unref(userHasSubscriptionWithTier)(
                  _unref(PREMIUM_CALCULATORS).activations,
                  _unref(SUBSCRIPTION_TIERS).consultant
                )
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(t)("labels.city")), 1),
                  _createVNode(GooglePlaceAutocompleteInput, { onPlaceSelected: handlePlaceSelected })
                ]))
              : _createCommentVNode("", true),
            (
                _unref(userHasSubscriptionWithTier)(
                  _unref(PREMIUM_CALCULATORS).activations,
                  _unref(SUBSCRIPTION_TIERS).family
                ) && _unref(familyStore).familyMembers.length > 0
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(AppDropdown, {
                    label: _unref(t)('labels.family-members'),
                    items: _unref(familyStore).familyMembers,
                    "selected-item": selectedFamilyMember.value,
                    "is-dropdown-open": isFamilyMembersDropdownOpen.value,
                    onToggle: _cache[2] || (_cache[2] = ($event: any) => (
                  isFamilyMembersDropdownOpen.value = !isFamilyMembersDropdownOpen.value
                ))
                  }, {
                    selectedItem: _withCtx(({ item }) => [
                      _createElementVNode("span", _hoisted_14, [
                        _createElementVNode("span", null, _toDisplayString(item?.name) + ", " + _toDisplayString(item?.city), 1),
                        _createVNode(ChevronIcon, {
                          class: _normalizeClass(["transition-transform", 
                        isFamilyMembersDropdownOpen.value ? 'rotate-180' : 'rotate-0'
                      ])
                        }, null, 8, ["class"])
                      ])
                    ]),
                    dropdownItem: _withCtx(({ item }) => [
                      _createElementVNode("div", {
                        class: "flex items-center px-4 text-base text-brown h-10 hover:bg-divider cursor-pointer select-none",
                        onClick: () => selectFamilyMember(item)
                      }, _toDisplayString(item?.name) + ", " + _toDisplayString(item?.city), 9, _hoisted_15)
                    ]),
                    _: 1
                  }, 8, ["label", "items", "selected-item", "is-dropdown-open"])
                ]))
              : _createCommentVNode("", true),
            (
                _unref(userHasSubscriptionWithTier)(
                  _unref(PREMIUM_CALCULATORS).activations,
                  _unref(SUBSCRIPTION_TIERS).individual
                ) && _unref(familyStore).familyMembers.length > 0
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(TextInput, {
                    label: _unref(t)('labels.family-members'),
                    "model-value": selectedFamilyMember.value?.name,
                    type: "text",
                    class: "pointer-events-none text-left"
                  }, null, 8, ["label", "model-value"])
                ]))
              : _createCommentVNode("", true),
            (
                !_unref(userHasSubscriptionWithTier)(
                  _unref(PREMIUM_CALCULATORS).activations,
                  _unref(SUBSCRIPTION_TIERS).consultant
                ) && _unref(familyStore).familyMembers.length == 0
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(AddOutlineButton, {
                    btnTextKey: "buttons.add-family-member",
                    btnWidth: "w-[235px]",
                    onClicked: handleOpenAddFamilyMemberModal
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          (hasCheckboxes.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activationGroup.value?.activationKeys, (key) => {
                    return (_openBlock(), _createElementBlock("div", { key: key }, [
                      _createElementVNode("label", _hoisted_20, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: key,
                          value: key,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedActivations).value = $event)),
                          class: "peer appearance-none min-w-6 min-h-6 rounded border border-ternary bg-secondary checked:bg-active checked:border-active cursor-pointer"
                        }, null, 8, _hoisted_21), [
                          [_vModelCheckbox, selectedActivations.value]
                        ]),
                        _createVNode(CheckIcon, { class: "absolute opacity-0 peer-checked:opacity-100 pointer-events-none ml-1" }),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)(`calculators.activations.activation_list.${key}`)), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(GradientButton, {
              class: "w-[153px] h-[46px] md:w-[191px] md:h-14",
              "bg-color": "bg-brown-gradient",
              "hover-bg-color": "bg-orange-gradient",
              text: _unref(t)('buttons.calculate'),
              onClick: handleSubmit,
              "is-loading": isLoading.value,
              "is-disabled": !isFieldsCorrect.value
            }, null, 8, ["text", "is-loading", "is-disabled"])
          ])
        ], 512), [
          [_vShow, isFormOpen.value]
        ])
      ]),
      (resultedActivations.value.length)
        ? (_openBlock(), _createBlock(ActivationResults, {
            key: 1,
            ref_key: "printableRef",
            ref: printableRef,
            "resulted-activations": resultedActivations.value
          }, null, 8, ["resulted-activations"]))
        : _createCommentVNode("", true),
      (activationRequested.value && resultedActivations.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)("calculators.activations.results.no_results")), 1)
          ]))
        : _createCommentVNode("", true),
      (resultedActivations.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createVNode(PrintButton, {
              "btn-classes": "size-11",
              "icon-classes": "mx-auto",
              onClick: _unref(handlePrint)
            }, null, 8, ["onClick"]),
            _createVNode(WordExporter, {
              activations: resultedActivations.value,
              activationKey: activationGroup.value?.key
            }, null, 8, ["activations", "activationKey"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_27, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-left text-[40px] font-medium leading-100p text-brown mb-6" }, " FAQ ", -1)),
        (activationGroup.value?.key !== undefined)
          ? (_openBlock(), _createBlock(AccordionFaq, {
              key: 0,
              faqTemplateName: `faq.activations.${activationGroup.value?.key}`,
              title: _unref(t)('calculators.activations.faq.activations.title'),
              collapseButtonText: 
            _unref(t)('calculators.activations.faq.activations.collapse_btn')
          
            }, null, 8, ["faqTemplateName", "title", "collapseButtonText"]))
          : _createCommentVNode("", true),
        _createVNode(ActivatorsAccordionFAQ),
        _createVNode(SectorsAccordionFAQ)
      ])
    ]),
    (activationGroup.value)
      ? (_openBlock(), _createBlock(BackSidebar, {
          key: 0,
          selectedActivation: activationGroup.value,
          onChangeActivationGroup: changeActivation
        }, null, 8, ["selectedActivation"]))
      : _createCommentVNode("", true),
    _createVNode(NotificationComponent)
  ]))
}
}

})